// material
import { Card, Typography, Box } from "@material-ui/core";
import { alpha, styled } from "@material-ui/core/styles";
import { AssignmentInd } from "@material-ui/icons";
// utils
import { fShortenNumber } from "../../../utils/formatNumber";

// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
	boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
	borderRadius: "10px",
	textAlign: "center",
	// padding: theme.spacing(5, 0),
	color: theme.palette.grey[100],
	backgroundColor: theme.palette.grey[400],
}));

const IconWrapperStyle = styled("div")(({ theme }) => ({
	margin: "auto",
	display: "flex",
	borderRadius: "50%",
	alignItems: "center",
	width: theme.spacing(6),
	height: theme.spacing(6),
	justifyContent: "center",
	marginBottom: theme.spacing(3),
	color: theme.palette.grey[100],
	backgroundImage: `linear-gradient(135deg, ${alpha(
		theme.palette.grey[400],
		0
	)} 0%, ${alpha(theme.palette.grey[900], 0.24)} 100%)`,
}));

// ----------------------------------------------------------------------

export default function Todo({ open }) {
	return (
		<RootStyle>
			<IconWrapperStyle>
				<AssignmentInd width={24} height={24} />
			</IconWrapperStyle>
			<Typography variant="h3">{fShortenNumber(open.total)}</Typography>
			<Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
				Open
			</Typography>
			<Box
				style={{
					display: "flex",
					height: "10vh",
					backgroundColor: "#919EAB",
					fontSize: "20px",
				}}
			>
				<span
					style={{
						display: "flex",
						justifyContent: "space-around",
						width: "100%",
						alignItems: "center",
						fontWeight: "bold",
						color: "#fff",
					}}
				>
					<p>
						{open?.late_data?.bulan} : {open?.late_data?.jumlah}
					</p>
					<p>
						{open?.current_data?.bulan} : {open?.current_data?.jumlah}
					</p>
				</span>
			</Box>
		</RootStyle>
	);
}
